export default __webpack_public_path__ + "static/media/coinsOrange@3x.9e1d5890.png";